import {TagCategory, TagCategoryEntity} from "../../../model/tag-category";
import {makeEntitySelectors} from "../base-entity-store";

export interface TagCategorySelectorProps {

}

const tagCategorySelectors = makeEntitySelectors<
  TagCategory,
  TagCategoryEntity,
  TagCategorySelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => TagCategoryEntity.from(value),
});

export const tagCategoriesSelector =
  (props?: TagCategorySelectorProps) =>
    tagCategorySelectors.listSelector(props);

export const tagCategorySelector =
  () => tagCategorySelectors.singleSelector();
